import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { parse } from 'papaparse';
import axios from 'axios';
import styles from './invite_user.module.scss';
import cx from "classnames";

const API_URL = process.env.REACT_APP_API_URL;
const INVITATIONS_BASE_URL = `${API_URL}/api/1.0/invitations`;

const InviteUser = () => {
  const account = useSelector((state) => state.accounts.account);

  const [users, setUsers] = useState([]);

  const [total, setTotal] = useState(0);
  const [uploaded, setUploaded] = useState(0);
  const [failed, setFailed] = useState(0);
  const [processingUser, setProcessingUser] = useState(null);

  const [processing, setProcessing] = useState(false);
  const required_fields = ['email','role']

  
  useEffect(async () => {

    if (users !== null && users !== undefined) {
      for (let i = 0; i < users.length; i++) {
        await createInvitation(users[i]);
      }

      setProcessingUser(false);
      setTimeout(() => {
        setProcessing(false);
      }, 2000);
    }

  }, [users]);

  useEffect(() => {

    if (processing === false) {
      setTotal(0);
      setUploaded(0);
      setFailed(0);
    }

  }, [processing])

  useEffect(() => {
    if (total > 0 && (uploaded + failed === total)) {
      toast.info(`Total users ${total}, Uploaded ${uploaded}, Failed ${failed}`);
    }
  }, [total, uploaded, failed]);

  const createInvitation = async (invite) => {
    try {
       
      if (invite.email === null || invite.email === undefined) {
        console.log("checking...")
        toast.error('failed to Invite user email not found')
        setFailed(prev => prev + 1);
        return;
      }
      setProcessingUser(invite);

      await axios({
        method: 'POST',
        url: INVITATIONS_BASE_URL,
        data: invite,
        params: { accountId: account.id },
      });

      setUploaded(prev => prev + 1);

      console.log(`${invite.email} success`);

    } catch (err) {
      if (err && !_.isEmpty(err.errors)) {
        let errors = err.errors;
        let error = errors[0];

        if (error.field !== null && error.field !== undefined) {
          toast.error(`${invite.email} ${error.field} ${error.message}`)
        } else {
          toast.error(`${error.message}`)
        }

        console.log(`${invite.email} error`);
      }

      setFailed(prev => prev + 1);
    }
  }


  const _handleCSVInvite = (e) => {
    parse(e.target.files[0], {
      header: true,
      complete: (results) => {

        let fields = results.meta.fields;

        let missingColumns = [];
        for (let i = 0; i < required_fields.length; i++) {
          let field = required_fields[i];
          let index = fields.indexOf(field);
          if (index === -1) {
            missingColumns.push(field);
          }
        }

        if (missingColumns.length > 0) {
          toast.error(`Missing columns: ${missingColumns.join(', ')}`);
          return;
        }

        setProcessing(true);
        const users = results.data;

        setTotal(users.length);
        setUsers(users);

      }
    });

  }
  return (
    <div>
      <div className={styles.buttonMove}>
        <div>
          <label className={styles.inviteButton} htmlFor="csvInput">
            Upload Invitations</label>
          <i className={cx("upload icon", styles.uploadFileicon)}></i>
        </div>
        <input
          type="file"
          accept=".csv"
          className={styles.fileUploadInput}
          onChange={_handleCSVInvite}
        />
      </div>
      <div>{processingUser && <span className={styles.creatingUser}>Inviting user {processingUser.email}...</span>} </div>
    </div>
  );
};

export default InviteUser;

